import { useNavigate } from 'react-router-dom'
import { Input, Table } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import { enterKeyHandler } from '../../../utils'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import TextInput from '../TextInput'
import '../Custom.css'
import StateInput from '../StateInput'
import CustomSelectListInput from '../CustomSelectListInput'

export default function PlaintiffUpdateForm({ location }) {
  console.log('PlaintiffUpdateForm rendered: ', location)

  let init = {
    firstName: '',
    lastName: '',
    caseName: '',
    state: '',
    plaintiffStatus: '',
    settlementStatus: '',
    docketNumber: '',
    courtLocation: '',
    repFirstName: '',
    repLastName: ''
  }

  const navigate = useNavigate()
  init = initialFormValues('PlaintiffUpdateForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('PlaintiffUpdateForm', navigate, inputs, 'fw.plaintiff_update')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Plaintiff Update' />
            <tbody>
              <TextInput label='First Name' name='firstName' handleInputChange={handleInputChange} defaultValue={inputs.firstName} />
              <TextInput label='Last Name' name='lastName' handleInputChange={handleInputChange} defaultValue={inputs.lastName} />
              <TextInput label='Case Name' name='caseName' handleInputChange={handleInputChange} defaultValue={inputs.caseName} />
              <tr>
                <td><b>State</b></td>
                <td><StateInput tenant='asbestos' handleChange={handleInputChange} defaultValue={inputs.state} /></td>
              </tr>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' allOption={true} defaultValue={inputs.plaintiffStatus} />
              <tr>
                <td><b>Settlement Status</b></td>
                <td>
                  <Input
                    type="select"
                    name="settlementStatus"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.settlementStatus}
                  >
                    <option value={'0'}></option>
                    <option value={'9400'}>Settled</option>
                    <option value={'9401'}>CWS</option>
                  </Input>
                </td>
              </tr>
              <TextInput label='Docket Number' name='docketNumber' handleInputChange={handleInputChange} defaultValue={inputs.docketNumber} />
              <TextInput label='Court Location' name='courtLocation' handleInputChange={handleInputChange} defaultValue={inputs.courtLocation} />
              <TextInput label='Representative/Executor First Name' name='repFirstName' handleInputChange={handleInputChange} defaultValue={inputs.repFirstName} />
              <TextInput label='Representative/Executor Last Name' name='repLastName' handleInputChange={handleInputChange} defaultValue={inputs.repLastName} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Search' />
      </form>
    </div>
  )
}
